import { Subject } from 'rxjs';

export abstract class WebSocketAbstract {
    // receive message from socket server
    onMessage: Subject<EnvelopBody> = new Subject();
    onStateChange: Subject<number> = new Subject();
    
    // update readyState
    stateChange () {
        this.onStateChange.next(this.readyState);  
    } 

    constructor(options: any, username: string) {
        this.connect(options, username);
    }

    // WebSocket readyState
    abstract readyState: number;

    // connect to socket server
    abstract connect(options: any, username: string): any;
    
    // close socket server
    abstract close(): any;

    // send message to socket server
    abstract send(envelop: WebSocketEnvelop): Promise<boolean>;
}

export enum WebSocketType {
    
    // send to the first address
    SEND = 'send',

    // publish to the all address
    PUBLISH = 'publish',
}

export class WebSocketEnvelop {
    type: WebSocketType | string = WebSocketType.PUBLISH;
    address: string;
    body: EnvelopBody;
}

export class EnvelopBody {
    uuid: string;
    application: string;
    message: EnvelopMessage;
    sender: string;
    alias: string[]; // receivers
    sent: number;
}

export class EnvelopMessage {
    sender: string;
    alert: string;
    content: string;
    joins: string;
    duration: string
// , joins?: string, duration?: string
    constructor(sender: string, content: string, joins?: string, duration?: string) {
        this.content = this.alert = content;
        this.sender = sender;
        if(!!joins ){
            this.joins = joins || sender;
        }
        this.duration = duration || "0";
    }
}
